import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { BadgeSeverity } from './contract/badge-severity.contract';
import { BadgeSize } from './contract/badge-size.contract';

@Component({
  selector: 'osp-badge',
  standalone: true,
  imports: [BadgeModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BadgeComponent {
  @HostBinding('class') protected hostClass = 'osp-badge';

  @Input() badgeSize: BadgeSize = undefined;
  @Input() value: string | number | null = null;
  @Input() badgeSeverity: BadgeSeverity = undefined;
  @Input() badgeDisabled = false;
  @Input() cssClass = '';
}
